import React, { useState } from 'react';
import { collection, addDoc } from 'firebase/firestore';
import { db } from '../FirebaseComp/firebase'; // Adjust path as needed
import './contactus.css';



const ContactUs = () => {

  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    subject: '',
    message: ''
  });


  const [submitted, setSubmitted] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      await addDoc(collection(db, 'contactus'), formData);
      setSubmitted(true);
      alert("We will contact you soon. Thank you for reaching out!");
    } catch (error) {
      console.error("Error saving contact message:", error);
      alert("There was an error. Please try again.");
    }
  };





 



  

  return (
    <div className="contact-page">
      {/* Hero Section */}
      <section className="contact-hero">
        <div className="contact-hero-overlay">
          <h1>Contact Asian Polytechnic Campus</h1>
          <p>We're here to help and answer any questions you might have</p>
        </div>
      </section>

      {/* Main Contact Content */}
      <div className="contact-container">
        {/* Contact Information Section */}
        <section className="contact-info-section">
          <div className="contact-info-card">
            <div className="info-icon">
              <i className="fas fa-map-marker-alt"></i>
            </div>
            <h3>Our Campus</h3>
            <p>932, Maradana Road</p>
            <p>Colombo 00800, Sri Lanka</p>
          </div>

          <div className="contact-info-card">
            <div className="info-icon">
              <i className="fas fa-phone-alt"></i>
            </div>
            <h3>Call Us</h3>
            <p>Main:  +94 112 682 277</p>
            <p>Admissions: +94 773 440 937</p>
            {/* <p>Fax: +94 112 345 680</p> */}
          </div>

          <div className="contact-info-card">
            <div className="info-icon">
              <i className="fas fa-envelope"></i>
            </div>
            <h3>Email Us</h3>
            <p>General: info@apc.com</p>
            <p>Admissions: admissions@apc.com</p>
            <p>Support: support@apc.com</p>
          </div>
        </section>

        {/* Map and Form Section */}
        <section className="map-form-section">
          <div className="map-container">
            <iframe 
              title="APC Campus Location"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3960.7513034374824!2d79.86938077448274!3d6.920306318426057!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3ae259744a1d7131%3A0x614fbd9988cf7417!2sEye%20Care%20Institute!5e0!3m2!1sen!2slk!4v1748941700830!5m2!1sen!2slk"
              width="100%" 
              height="100%" 
              style={{border:0}} 
              allowFullScreen="" 
              loading="lazy"
            ></iframe>
          </div>

          <div className="form-container">
      <h2>Send Us a Message</h2>
      {submitted ? (
        <div className="success-message">
          <i className="fas fa-check-circle"></i>
          <p>Thank you for your message! We'll get back to you soon.</p>
        </div>
      ) : (
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="name">Full Name</label>
            <input
              type="text"
              id="name"
              name="name"
              value={formData.name}
              onChange={handleChange}
              required
            />
          </div>

          <div className="form-group">
            <label htmlFor="email">Email Address</label>
            <input
              type="email"
              id="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              required
            />
          </div>

          <div className="form-group">
            <label htmlFor="phone">Phone Number</label>
            <input
              type="tel"
              id="phone"
              name="phone"
              value={formData.phone}
              onChange={handleChange}
            />
          </div>

          <div className="form-group">
            <label htmlFor="subject">Subject</label>
            <select
              id="subject"
              name="subject"
              value={formData.subject}
              onChange={handleChange}
              required
            >
              <option value="">Select a subject</option>
              <option value="Admissions">Admissions</option>
              <option value="Academics">Academics</option>
              <option value="Administration">Administration</option>
              <option value="Facilities">Facilities</option>
              <option value="Other">Other</option>
            </select>
          </div>

          <div className="form-group">
            <label htmlFor="message">Your Message</label>
            <textarea
              id="message"
              name="message"
              rows="5"
              value={formData.message}
              onChange={handleChange}
              required
            ></textarea>
          </div>

          <button type="submit" className="submit-btn">
            Send Message
          </button>
        </form>
      )}
    </div>
        </section>

        {/* Department Contacts */}
        <section className="departments-section">
          <h2>Contact Specific Departments</h2>
          <div className="departments-grid">
            <div className="department-card">
              <h3>Admissions Office</h3>
              <p><i className="fas fa-phone"></i> +94 112 345 679</p>
              <p><i className="fas fa-envelope"></i> admissions@apc.com</p>
              <p><i className="fas fa-clock"></i> Mon-Fri: 8:30 AM - 4:30 PM</p>
            </div>

            <div className="department-card">
              <h3>Registrar's Office</h3>
              <p><i className="fas fa-phone"></i> +94 112 345 681</p>
              <p><i className="fas fa-envelope"></i> registrar@apc.com</p>
              <p><i className="fas fa-clock"></i> Mon-Fri: 9:00 AM - 3:00 PM</p>
            </div>

            <div className="department-card">
              <h3>Student Services</h3>
              <p><i className="fas fa-phone"></i> +94 112 345 682</p>
              <p><i className="fas fa-envelope"></i> studentservices@apc.com</p>
              <p><i className="fas fa-clock"></i> Mon-Fri: 8:00 AM - 5:00 PM</p>
            </div>

            <div className="department-card">
              <h3>IT Support</h3>
              <p><i className="fas fa-phone"></i> +94 112 345 683</p>
              <p><i className="fas fa-envelope"></i> itsupport@apc.com</p>
              <p><i className="fas fa-clock"></i> 24/7 Help Desk</p>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
};

export default ContactUs;